/* Firkin Jelly — bandeaux défilants tactiles (vidéos + avis)
   Toucher = pause tant que le doigt est posé · glisser = revenir/avancer · reprise immédiate en lâchant
   Perf : l'animation s'arrête quand le bandeau n'est pas à l'écran (moins de travail pour le téléphone) */
(function () {
  if (window.__fjDefilementInteractif) return;
  window.__fjDefilementInteractif = true;

  /* ===== Réglages ===== */
  var DELAI_REPRISE = 0; // reprise immédiate dès qu'on lâche (mettre 2000 = 2 s, etc.)
  var SELECTEURS = '.wb-mqd__track, .wb-ad__track'; // bandeaux vidéos + avis

  function init(track) {
    if (track.dataset.fjDrag) return;
    track.dataset.fjDrag = '1';

    var zone = track.parentElement;
    var cs = getComputedStyle(track);
    var d = (cs.animationDuration || '').split(',')[0].trim();
    var duree = d.indexOf('ms') > -1 ? parseFloat(d) / 1000 : parseFloat(d);
    if (!duree || duree <= 0) duree = 40;
    var inverse = (cs.animationDirection || '').split(',')[0].trim().indexOf('reverse') > -1;

    // Position actuelle pour reprendre sans saut
    var x = 0;
    try { if (cs.transform && cs.transform !== 'none') x = new DOMMatrixReadOnly(cs.transform).m41; } catch (e) {}

    // On coupe l'animation CSS et on la pilote nous-mêmes
    track.style.setProperty('animation', 'none', 'important');
    track.style.willChange = 'transform';
    zone.style.touchAction = 'pan-y';
    zone.style.cursor = 'grab';
    zone.style.userSelect = 'none';

    var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var boucle = 0, vitesse = 0;
    function mesurer() {
      boucle = track.scrollWidth / 2;
      vitesse = reduit ? 0 : boucle / duree;
    }
    mesurer();
    if (window.ResizeObserver) new ResizeObserver(mesurer).observe(track);
    else window.addEventListener('resize', mesurer);

    function caler(v) {
      if (!boucle) return v;
      v = v % boucle;
      if (v > 0) v -= boucle;
      return v;
    }

    var pause = false, survol = false, appui = false, glisse = false, aBouge = false;
    var debutX = 0, debutY = 0, dernierX = 0, dernierT = 0, vel = 0, elan = 0, minuteur;
    var avant = performance.now();
    var visible = true, tourne = false;

    function image(t) {
      if (!visible && !appui) { tourne = false; return; }
      var dt = Math.min((t - avant) / 1000, 0.1);
      avant = t;
      if (!appui) {
        if (Math.abs(elan) > 5) {
          x += elan * dt;
          elan *= Math.pow(0.04, dt);
        } else {
          elan = 0;
          if (!pause && !survol) x += (inverse ? 1 : -1) * vitesse * dt;
        }
      }
      x = caler(x);
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
      requestAnimationFrame(image);
    }
    function demarrer() {
      if (tourne) return;
      tourne = true;
      avant = performance.now();
      requestAnimationFrame(image);
    }
    demarrer();

    // Arrête l'animation quand le bandeau sort de l'écran, la relance quand il revient
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        if (visible) demarrer();
      }, { rootMargin: '100px 0px' }).observe(zone);
    }

    function reprendreBientot(delai) {
      clearTimeout(minuteur);
      delai = delai == null ? DELAI_REPRISE : delai;
      if (delai <= 0) { pause = false; return; }
      pause = true;
      minuteur = setTimeout(function () { pause = false; }, delai);
    }

    // Souris : pause au survol (comme avant)
    zone.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') survol = true; });
    zone.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') survol = false; });

    zone.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      appui = true; glisse = false; aBouge = false;
      debutX = dernierX = e.clientX; debutY = e.clientY;
      dernierT = performance.now(); vel = 0; elan = 0;
      pause = true; clearTimeout(minuteur);
      demarrer();
    });

    zone.addEventListener('pointermove', function (e) {
      if (!appui) return;
      var dx = e.clientX - debutX, dy = e.clientY - debutY;
      if (!glisse) {
        if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          glisse = true; aBouge = true;
          try { zone.setPointerCapture(e.pointerId); } catch (_) {}
          zone.style.cursor = 'grabbing';
        } else if (Math.abs(dy) > 10) {
          appui = false; reprendreBientot(); return; // l'utilisateur fait défiler la page verticalement
        } else return;
      }
      e.preventDefault();
      var now = performance.now(), ddt = (now - dernierT) / 1000;
      x += e.clientX - dernierX;
      if (ddt > 0) vel = 0.8 * ((e.clientX - dernierX) / ddt) + 0.2 * vel;
      dernierX = e.clientX; dernierT = now;
    }, { passive: false });

    function fin() {
      if (!appui) return;
      appui = false;
      zone.style.cursor = 'grab';
      if (glisse) {
        if (performance.now() - dernierT < 100) elan = Math.max(-3000, Math.min(3000, vel));
        survol = false; // après un glissement à la souris, on repart aussi tout de suite
      }
      glisse = false;
      reprendreBientot();
    }
    zone.addEventListener('pointerup', fin);
    zone.addEventListener('pointercancel', fin);

    // Empêche d'ouvrir un lien par erreur après un glissement
    zone.addEventListener('click', function (e) {
      if (aBouge) { e.preventDefault(); e.stopPropagation(); aBouge = false; }
    }, true);
    zone.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Pavé tactile / molette horizontale
    zone.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        x -= e.deltaX;
        reprendreBientot(Math.max(DELAI_REPRISE, 250));
      }
    }, { passive: false });
  }

  function lancer() { document.querySelectorAll(SELECTEURS).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer);
  else lancer();
  document.addEventListener('shopify:section:load', lancer);
})();
